import { HintTypeEnum } from '@nankai/online/constants';

export default {
  seat: {
    parenthesis: '({{text}})',
    header: {
      station: 'ご購入情報を入力してください',
      seat: '座席を選択してください',
      start: '{{time}}発',
      confirm: '座席確認',
      bookingConfirm: '※決済完了かつ予約完了後に正式確保となります。'
    },
    button: {
      back: '戻る',
      next: '次へ',
      change: '変更'
    },
    selectSeatType: {
      title: '座席選択方式',
      auto: '自動割り当て',
      manual: '手動選択'
    },
    station: {
      date: '乗車日',
      startStation: '乗車駅',
      endStation: '降車駅',
      startStationTip: '乗車駅を選択してください',
      endStationTip: '降車駅を選択してください'
    },
    train: {
      header: '列車を選択してください',
      emptySeat: '空席',
      trainLabel: '{{trainName}}{{trainServiceNo}}号'
    },
    carriage: {
      carriageCar: '{{carNo}}号車',
      directionUpTitle: '↑ なんば方面',
      directionDownTitle: '↑ 高野山方面',
      car1Notice1: '【ご注意】 2・4・23・27番席は窓がありません。',
      car1Notice2: '乗務員室側は壁のため、前方の景色はご覧いただけません。'
    },
    wheelchairConfirm: {
      title: '車椅子優先席を選択されました。',
      content:
        'この座席は、車椅子をご利用のお客様優先です。以下の点をご確認ください。',
      notice1: '車椅子をご利用のお客様優先となります。',
      notice2: '一般のご利用のお客様はご配慮ください。',
      confirmText: 'このまま選択を続けますか？',
      cancel: 'キャンセル',
      confirm: 'はい'
    },
    confirmChange: {
      title: 'ご利用の予約を以下に変更します',
      before: '変更前',
      after: '変更後',
      label: {
        trainName: '列車名',
        date: '乗車日',
        time: '乗車時刻',
        seat: '座席',
        seatWithCar: '座席 ({{carNo}}号車)'
      }
    },
    hintType: {
      [HintTypeEnum.OutOfAvailableTerm]:
        '選択した日付は販売開始前です。（乗車日の1か月前から購入可能です）',
      [HintTypeEnum.EndOfService]:
        '購入可能な列車がございません。<br />運行情報をご確認ください。'
    }
  },
  error: {
    // doto: 別の言語に展開する
    invalidParams:
      'ご指定の条件に誤りがあります。お手数ですが、最初からやり直してください',
    lineIdInvalid:
      '路線が選択されていません。お手数ですが、最初からやり直してください',
    productIdInvalid:
      '選択した商品が不正です。お手数ですが、最初からやり直してください',
    forbidden:
      'この操作は許可されていません。お手数ですが、最初からやり直してください',
    seatChangeCountExceeded: '座席変更回数が2回までです',
    notFound:
      '指定されたページが見つかりません。お手数ですが、最初からやり直してください',
    system: 'システムエラーが発生しました。しばらく経ってから再度お試しください'
  }
};
